module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_Norm-Center",
    attrs: {
      "id": "auto_bookmark_table_of_contents_1"
    }
  }, [_c('span', [_vm._v("Ce livre est dédié à Jordan L. Hawk, que j’ai le plaisir de connaître depuis plusieurs années, et qui non seulement sort des sentiers battus, mais semble en plus recevoir le soutien d’une fanfare de mariachi quand elle le fait. Jordan, puissent tes chapeaux en forme de calamar t’aller parfaitement et tes arcs-en-ciel n’être faits que de magie.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Norm-Center"
  }, [_c('span', [_vm._v("Mais aussi à Maite, qui me fait rire et qui accepte d’aller me chercher des tranches de citron "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("li hing mui")]), _vm._v(" au Family Grocer de Kane’ohe. Partage tes bretzels. T’as pas le choix. Il faut être gentille. Ou alors, donne quelques miettes à Mike. Bisous.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Alignment__And__Left_Indent__And__Tabs"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28c78852","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0003.vue
// module id = 63
// module chunks = 0